<p-confirmDialog key="UnassignedTable" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="Title">
	<h4>Unassigned Students:</h4>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstPerson"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="SelectedStudents"
		dataKey="PersonID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->
				<th></th>

				<!--LastName-->
				<th>
					<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--FirstName-->
				<th>
					<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--StudentID-->
				<th>
					<p-columnFilter type="text" field="StudentID" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--Homeroom-->
				<th>
					<p-columnFilter type="text" field="Homeroom" matchMode="contains" [showMenu]="true"></p-columnFilter>

					<!-- <p-columnFilter field="Homeroom" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown #filterHomeroom [ngModel]="value" [options]="lstHomeroom" (onChange)="filter($event.value)"
								placeholder="Any" [showClear]="true">
								<ng-template let-value pTemplate="item">
									<span>{{value}}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter> -->
				</th>

				<!--ActiveDesc-->
				<th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th>
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
				<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
				<th pSortableColumn="StudentID">Student ID<p-sortIcon field="StudentID"></p-sortIcon></th>
				<th pSortableColumn="Homeroom">Homeroom<p-sortIcon field="Homeroom"></p-sortIcon></th>
				<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Person>
			<tr [pSelectableRow]="Person">
				<td>
					<p-tableCheckbox [pSelectableRow]="Person" [value]="Person"></p-tableCheckbox>
				</td>
				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Person[col.field] }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="Person.Active == 1 ? 'Black' : 'Red'">
					{{ Person.ActiveDesc }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<div class="Buttons">
	<button [disabled]="loading == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAssignStudent()">Assign</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
